function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { Fragment, forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { getEnv } from "../../utils";
import { getPrefixCls } from "../../utils/common";
import "./style.less";
import CommonPool from "../../store/commonPool";
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import { Button as CommonButton, Toast, Payment } from "../../common";
import { getUserLoginInfo } from "../../service/userInfo";
import { ProductTypeBtnTexts } from "../../utils/constants";
import { handleCreateOrder } from "../../utils/payment";
import qs from 'query-string';
import { LStorage } from "../Login/utils";
import { getAppletUrlSchema } from "../../service/api";
import { useEventPerform } from "../../hooks/useEventPerform";
import { sensorsTrack } from "../../service/sensors";
import { useAppJump } from "../../hooks/useAppJump";
import { GuidePage } from "../../common/index";
import { useToggleVisible } from "../../hooks/useToggleVisible";
import { scrollToAnchor } from "../../utils/index";
var prefixCls = getPrefixCls('SmButton');
// 需要将Ref共享到句柄池上时，需要使用forwardRef+useImperativeHandle将ref及需要暴露的属性共享出去
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$schema, _props$schema$params, _props$params, _props$schema2, _props$schema2$params, _props$params2, _props$schema3, _props$schema3$params, _props$params3, _props$schema4, _props$schema4$params, _Object$keys;
  var title = props.title,
    text = props.text,
    hasHeartJump = props.hasHeartJump,
    _props$btnColor = props.btnColor,
    btnColor = _props$btnColor === void 0 ? '#ff6e00' : _props$btnColor,
    _props$width = props.width,
    width = _props$width === void 0 ? '100%' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '40px' : _props$height,
    _props$interactionLis = props.interactionListSchema,
    interactionListSchema = _props$interactionLis === void 0 ? [] : _props$interactionLis,
    _props$showPrice = props.showPrice,
    showPrice = _props$showPrice === void 0 ? true : _props$showPrice,
    openSetting = props.openSetting,
    productInfo = props.productInfo,
    _props$justPay = props.justPay,
    justPay = _props$justPay === void 0 ? false : _props$justPay,
    _props$devPay = props.devPay,
    devPay = _props$devPay === void 0 ? false : _props$devPay,
    style = props.style,
    _props$fixedBottom = props.fixedBottom,
    fixedBottom = _props$fixedBottom === void 0 ? true : _props$fixedBottom,
    cusPayType = props.cusPayType,
    fontSize = props.fontSize,
    _props$isNavigateAppl = props.isNavigateApplets,
    isNavigateApplets = _props$isNavigateAppl === void 0 ? false : _props$isNavigateAppl,
    appId = props.appId,
    backgroundImage = props.backgroundImage,
    _props$backTextShow = props.backTextShow,
    backTextShow = _props$backTextShow === void 0 ? 'hidden' : _props$backTextShow,
    _props$isRightAngle = props.isRightAngle,
    isRightAngle = _props$isRightAngle === void 0 ? false : _props$isRightAngle,
    _props$isNavigateUrl = props.isNavigateUrl,
    isNavigateUrl = _props$isNavigateUrl === void 0 ? false : _props$isNavigateUrl,
    navigateUrl = props.navigateUrl,
    customUrl = props.customUrl,
    isDownloadApp = props.isDownloadApp,
    landingPageUrl = props.landingPageUrl,
    appChannel = props.appChannel,
    wechatAppId = props.wechatAppId,
    androidStorePriority = props.androidStorePriority;
  var _ref = productInfo || (props === null || props === void 0 ? void 0 : (_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.productInfo) || {},
    primaryProduct = _ref.product,
    _ref$activity = _ref.activity,
    activityDetail = _ref$activity === void 0 ? {} : _ref$activity,
    products = _ref.products,
    hasBuy = _ref.hasBuy,
    orderProduct = _ref.orderProduct,
    disabled = _ref.hasDisabled,
    productType = _ref.productType,
    isTrial = _ref.isTrial;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    userInfo = _useState2[0],
    setUserInfo = _useState2[1]; // 用户信息
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1]; // 是否显示支付弹窗
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loginStatus = _useState6[0],
    setLoginStatus = _useState6[1];
  var _useState7 = useState(2),
    _useState8 = _slicedToArray(_useState7, 2),
    payType = _useState8[0],
    setPayType = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedProductStatus = _useState10[0],
    setSelectedProductStatus = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loading = _useState12[0],
    setLoading = _useState12[1];
  var _useToggleVisible = useToggleVisible(),
    tabVisible = _useToggleVisible.visible,
    toggleVisible = _useToggleVisible.toggleVisible;
  var product = useMemo(function () {
    return primaryProduct || (products && (activityDetail.channelDeliveryGroupId || products.length === 1) ? products[0] : null) || (isTrial ? products[0] : null) || CommonPool.getSelectedProduct();
  }, [primaryProduct, products, activityDetail, isTrial, selectedProductStatus]);
  var resourceId = useMemo(function () {
    return wechatAppId === null || wechatAppId === void 0 ? void 0 : wechatAppId.split('--')[0];
  }, [wechatAppId]);
  useEffect(function () {
    sensorsTrack('SCRM_downloadapp_pageview', {
      resource_id: resourceId,
      is_download_app: isDownloadApp
    });
  }, [resourceId, isDownloadApp]);
  useEffect(function () {
    if (cusPayType) {
      setPayType(cusPayType);
    }
  }, [cusPayType]);
  useEffect(function () {
    var element = document.querySelector('.fr-field.w-100.fr-field-complex.fr-field-object') || document.querySelector('.lowTableUI') || document.body;
    if (!element) return;
    if (fixedBottom) {
      element.style.paddingBottom = '60px';
    } else {
      element.style.paddingBottom = '0';
    }
  }, [fixedBottom]);
  var params = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.params) || ((_props$schema2 = props.schema) === null || _props$schema2 === void 0 ? void 0 : (_props$schema2$params = _props$schema2.params) === null || _props$schema2$params === void 0 ? void 0 : _props$schema2$params.params);
  var search = ((_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.search) || ((_props$schema3 = props.schema) === null || _props$schema3 === void 0 ? void 0 : (_props$schema3$params = _props$schema3.params) === null || _props$schema3$params === void 0 ? void 0 : _props$schema3$params.search);
  var source = ((_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : _props$params3.source) || ((_props$schema4 = props.schema) === null || _props$schema4 === void 0 ? void 0 : (_props$schema4$params = _props$schema4.params) === null || _props$schema4$params === void 0 ? void 0 : _props$schema4$params.source);
  var isDev = source === 'development' || devPay;
  var isPreview = (props === null || props === void 0 ? void 0 : props.componentRenderStatus) === 'preview';
  var isShowMockPrice = isDev || isPreview;
  var hasChooseProduct = !!((_Object$keys = Object.keys(product)) !== null && _Object$keys !== void 0 && _Object$keys.length);
  var searchParse = qs.parse(search);
  useImperativeHandle(ref, function () {
    return {
      title: title,
      loginSuccess: loginSuccess,
      initEvent: initEvent,
      updateSelectProduct: updateSelectProduct,
      modalClose: modalClose,
      toggleVisible: toggleVisible
    };
  });
  useEffect(function () {
    getUserInfo();
  }, [loginStatus]);
  var _useEventPerform = useEventPerform(_objectSpread(_objectSpread({}, props), {}, {
      interactionListSchema: interactionListSchema,
      userInfo: userInfo,
      product: product,
      compsGuid: props.compsGuid || '',
      hasBuy: hasBuy,
      hasChooseProduct: hasChooseProduct,
      isDev: isDev,
      isPreview: isPreview,
      visible: visible,
      setVisible: setVisible,
      productInfo: productInfo,
      search: search,
      payType: payType,
      params: params
    })),
    removeEvent = _useEventPerform.removeEvent,
    initEvent = _useEventPerform.initEvent,
    handleEventStart = _useEventPerform.handleEventStart;
  var isDownloadButton = isDownloadApp && wechatAppId;
  var _useAppJump = useAppJump(wechatAppId, (searchParse === null || searchParse === void 0 ? void 0 : searchParse.targetUrl) || landingPageUrl, appChannel, androidStorePriority),
    jumpToApp = _useAppJump.jumpToApp,
    jumpLoading = _useAppJump.loading,
    guideOpen = _useAppJump.guideOpen,
    guideClose = _useAppJump.guideClose;
  var modalClose = function modalClose(type, status) {
    if (type === 'multiProductsModal') {
      switch (status) {
        case 'success':
          removeEvent();
          break;
        default:
          initEvent();
          break;
      }
    }
  };
  var updateSelectProduct = function updateSelectProduct() {
    setSelectedProductStatus({});
  };
  var getUserInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUserLoginInfo();
          case 2:
            res = _context.sent;
            setUserInfo(res);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getUserInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  // onlyNotification 是否仅通知，当组件触发登录，并且登录组件未配置事件时，继续走组件事件，反之仅通知更新
  var loginSuccess = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _props$customFns, _props$customFns$init;
      var onlyNotification,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            onlyNotification = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
            setLoginStatus(true);
            _context2.next = 4;
            return props === null || props === void 0 ? void 0 : (_props$customFns = props.customFns) === null || _props$customFns === void 0 ? void 0 : (_props$customFns$init = _props$customFns.initProductInfo) === null || _props$customFns$init === void 0 ? void 0 : _props$customFns$init.call(_props$customFns);
          case 4:
            _context2.next = 6;
            return getUserInfo();
          case 6:
            if (!(onlyNotification || !openSetting)) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return");
          case 8:
            // 登录成功，订单提交  =====》》迁移至登录配置
            removeEvent();
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function loginSuccess() {
      return _ref3.apply(this, arguments);
    };
  }();
  var getFormResult = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var refs, qaAnswer, _qs$parse, x_field_1, sourceType, promotionUserId, promotionUserType, key, _refs$key, _refs$key$ref, _refs$key$ref$current, _refs$key$ref$current2, _refs$key$ref$current3, _refs$key2, _refs$key2$ref, _refs$key2$ref$curren, _refs$key2$ref$curren2, _refs$key2$ref$curren3, _refs$key3, id;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            refs = CommonPool.getRefs();
            if (!(activityDetail !== null && activityDetail !== void 0 && activityDetail.detailPageSurvey)) {
              _context3.next = 26;
              break;
            }
            _qs$parse = qs.parse(search), x_field_1 = _qs$parse.x_field_1, sourceType = _qs$parse.sourceType, promotionUserId = _qs$parse.promotionUserId, promotionUserType = _qs$parse.promotionUserType;
            _context3.t0 = _regeneratorRuntime().keys(refs);
          case 4:
            if ((_context3.t1 = _context3.t0()).done) {
              _context3.next = 21;
              break;
            }
            key = _context3.t1.value;
            if (!((_refs$key = refs[key]) !== null && _refs$key !== void 0 && (_refs$key$ref = _refs$key.ref) !== null && _refs$key$ref !== void 0 && (_refs$key$ref$current = _refs$key$ref.current) !== null && _refs$key$ref$current !== void 0 && (_refs$key$ref$current2 = (_refs$key$ref$current3 = _refs$key$ref$current).getActivityQa) !== null && _refs$key$ref$current2 !== void 0 && _refs$key$ref$current2.call(_refs$key$ref$current3))) {
              _context3.next = 19;
              break;
            }
            _context3.prev = 7;
            _context3.next = 10;
            return (_refs$key2 = refs[key]) === null || _refs$key2 === void 0 ? void 0 : (_refs$key2$ref = _refs$key2.ref) === null || _refs$key2$ref === void 0 ? void 0 : (_refs$key2$ref$curren = _refs$key2$ref.current) === null || _refs$key2$ref$curren === void 0 ? void 0 : (_refs$key2$ref$curren2 = (_refs$key2$ref$curren3 = _refs$key2$ref$curren).activityQaVerify) === null || _refs$key2$ref$curren2 === void 0 ? void 0 : _refs$key2$ref$curren2.call(_refs$key2$ref$curren3);
          case 10:
            qaAnswer = _context3.sent;
            _context3.next = 19;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t2 = _context3["catch"](7);
            id = (_refs$key3 = refs[key]) === null || _refs$key3 === void 0 ? void 0 : _refs$key3.title; // 表单校验不通过时定位到表单
            scrollToAnchor(id);
            Toast.show({
              content: '请填写账号信息'
            });
            return _context3.abrupt("return", false);
          case 19:
            _context3.next = 4;
            break;
          case 21:
            !!qaAnswer.questionAnswerList && qaAnswer.questionAnswerList.forEach(function (e) {
              e.answerFlag = e.answer ? 1 : 0;
              e.question = {
                name: e.questionName
              };
            });
            // 如果是秒杀 0 元 非正式课     有gliveid即非正课
            if (!!orderProduct && !!orderProduct.gliveId && activityDetail.price === 0 && activityDetail.activityWay === 'ACTIVITY_SECKILL') {
              qaAnswer.ext = {
                xField: x_field_1,
                projectId: activityDetail.projectId,
                activityId: activityDetail.id,
                promotionUserId: parseInt(promotionUserId || '') || null,
                landingPageId: activityDetail.id,
                promotionUserType: promotionUserType || null
              };
              qaAnswer.sourceType = sourceType || 'scrm';
            }
            qaAnswer.x_field_1 = qs.parse(search)['x_field_1'];
            LStorage.set('qaAnswer', qaAnswer);
            return _context3.abrupt("return", true);
          case 26:
            return _context3.abrupt("return", true);
          case 27:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[7, 13]]);
    }));
    return function getFormResult() {
      return _ref4.apply(this, arguments);
    };
  }();
  var onClick = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _qs$parse2, x_field_1, _customUrl$split, _customUrl$split2, appletPage, _search, customPath, customQuery, _params, urlQuery, res, formValidate, _props$customFns2, _props$customFns2$han;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _qs$parse2 = qs.parse(search), x_field_1 = _qs$parse2.x_field_1; // 跳转url
            if (isNavigateUrl && navigateUrl) {
              if (window) {
                window.location.href = navigateUrl;
              } else {
                //
              }
            }
            // 跳转小程序
            if (!(isNavigateApplets && appId)) {
              _context4.next = 17;
              break;
            }
            sensorsTrack('SCRM_activitydetail_buy_click', {
              scrm_activity_way: activityDetail.activityWay,
              scrm_activity_name: activityDetail.name,
              scrm_activity_id: activityDetail.id,
              scrm_product_name: product.productName || '',
              scrm_plan_name: activityDetail.planName,
              scrm_plan_id: activityDetail.planId,
              scrm_xField: x_field_1 || ''
            });
            setLoading(true);
            appletPage = '/pages/spike/seckill/addteacher/index';
            _search = window && window.location.search.substring(1);
            customPath = customUrl === null || customUrl === void 0 ? void 0 : (_customUrl$split = customUrl.split('?')) === null || _customUrl$split === void 0 ? void 0 : _customUrl$split[0];
            customQuery = (customUrl === null || customUrl === void 0 ? void 0 : (_customUrl$split2 = customUrl.split('?')) === null || _customUrl$split2 === void 0 ? void 0 : _customUrl$split2[1]) || '';
            _params = _objectSpread(_objectSpread({}, qs.parse(customQuery)), qs.parse(_search));
            urlQuery = qs.stringify(_params);
            _context4.next = 13;
            return getAppletUrlSchema({
              appletAppid: appId,
              path: customPath || appletPage,
              query: urlQuery
            });
          case 13:
            res = _context4.sent;
            setLoading(false);
            if (res.status === 0) {
              window.location.href = res.result;
            }
            return _context4.abrupt("return");
          case 17:
            if (!isDownloadButton) {
              _context4.next = 22;
              break;
            }
            sensorsTrack('SCRM_activitydetail_buy_click', {
              scrm_activity_way: activityDetail.activityWay,
              scrm_activity_name: activityDetail.name,
              scrm_activity_id: activityDetail.id,
              scrm_product_name: product.productName || '',
              scrm_plan_name: activityDetail.planName,
              scrm_plan_id: activityDetail.planId,
              scrm_xField: x_field_1 || ''
            });
            sensorsTrack('SCRM_donwloadapp_click', {
              resource_id: resourceId,
              is_download_app: isDownloadApp
            });
            jumpToApp === null || jumpToApp === void 0 ? void 0 : jumpToApp();
            return _context4.abrupt("return");
          case 22:
            _context4.next = 24;
            return getFormResult();
          case 24:
            formValidate = _context4.sent;
            if (formValidate) {
              _context4.next = 27;
              break;
            }
            return _context4.abrupt("return");
          case 27:
            if (!justPay) {
              _context4.next = 33;
              break;
            }
            if (!isDev) {
              _context4.next = 32;
              break;
            }
            Toast.show({
              content: '支付成功'
            });
            setVisible(false);
            return _context4.abrupt("return");
          case 32:
            return _context4.abrupt("return", handleCreateOrder(_objectSpread(_objectSpread({}, props), {}, {
              search: qs.stringify(qs.parse(search)),
              userInfo: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userInfo,
              product: product,
              productInfo: productInfo,
              payType: payType,
              closePayModal: function closePayModal() {
                return setVisible(false);
              }
            })));
          case 33:
            if (!(hasBuy && !visible)) {
              _context4.next = 36;
              break;
            }
            (_props$customFns2 = props.customFns) === null || _props$customFns2 === void 0 ? void 0 : (_props$customFns2$han = _props$customFns2.handleStudy) === null || _props$customFns2$han === void 0 ? void 0 : _props$customFns2$han.call(_props$customFns2, {
              productType: productType,
              hasBuy: hasBuy,
              orderProduct: orderProduct
            });
            return _context4.abrupt("return");
          case 36:
            if (openSetting) {
              _context4.next = 38;
              break;
            }
            return _context4.abrupt("return");
          case 38:
            // 交互逻辑
            // handleInteraction();
            sensorsTrack('SCRM_activitydetail_buy_click', {
              scrm_activity_way: activityDetail.activityWay,
              scrm_activity_name: activityDetail.name,
              scrm_activity_id: activityDetail.id,
              scrm_product_name: product.productName || '',
              scrm_plan_name: activityDetail.planName,
              scrm_plan_id: activityDetail.planId,
              scrm_xField: x_field_1 || ''
            });
            handleEventStart();
          case 40:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function onClick() {
      return _ref5.apply(this, arguments);
    };
  }();
  var fixedStyle = fixedBottom && !justPay ? {
    position: 'fixed',
    left: 0,
    bottom: 0,
    right: 0,
    paddingBottom: '15px',
    zIndex: 998
  } : {};
  useEffect(function () {
    getEnv();
  }, []);
  var ActivityButton = function ActivityButton(_ref6) {
    var _width$split, _width$split$call, _width$split$call$inc, _height$toString, _height$toString$call, _height$toString2, _height$toString2$cal, _product$price, _product$price$toStri, _product$price2, _product$price2$toStr, _activityDetail$price, _activityDetail$price2;
    var customText = _ref6.customText;
    var commonButtonStyle = {
      backgroundColor: btnColor,
      width: width !== null && width !== void 0 && (_width$split = width.split) !== null && _width$split !== void 0 && (_width$split$call = _width$split.call(width, '')) !== null && _width$split$call !== void 0 && (_width$split$call$inc = _width$split$call.includes) !== null && _width$split$call$inc !== void 0 && _width$split$call$inc.call(_width$split$call, '%') ? width : width + 'px',
      height: height !== null && height !== void 0 && (_height$toString = height.toString) !== null && _height$toString !== void 0 && (_height$toString$call = _height$toString.call(height)) !== null && _height$toString$call !== void 0 && _height$toString$call.includes('px') ? height : height + 'px',
      borderRadius: isRightAngle ? 0 : height !== null && height !== void 0 && (_height$toString2 = height.toString) !== null && _height$toString2 !== void 0 && (_height$toString2$cal = _height$toString2.call(height)) !== null && _height$toString2$cal !== void 0 && _height$toString2$cal.includes('px') ? height : height + 'px'
    };
    if (backgroundImage) {
      commonButtonStyle.backgroundImage = "url(".concat(backgroundImage, ")");
      commonButtonStyle.backgroundSize = 'contain';
      commonButtonStyle.backgroundRepeat = 'no-repeat';
      commonButtonStyle.backgroundColor = 'rgba(0,0,0,0)';
    }
    return /*#__PURE__*/React.createElement(CommonButton, {
      disabled: disabled || loading,
      color: "primary",
      onClick: onClick,
      style: commonButtonStyle,
      loading: loading || jumpLoading,
      className: hasHeartJump === 'heart' ? "".concat(prefixCls, "-button ").concat(prefixCls, "-heart") : "".concat(prefixCls, "-button")
    }, (!backgroundImage || backTextShow === 'visible') && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-buttonText"),
      style: {
        fontSize: "".concat(fontSize || 18, "px")
      }
    }, !hasBuy && showPrice && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-price")
    }, /*#__PURE__*/React.createElement("div", null, "\xA5"), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-price-number")
    }, isShowMockPrice ? (product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$toStri = _product$price.toString) === null || _product$price$toStri === void 0 ? void 0 : _product$price$toStri.call(_product$price)) || '0.01' : (product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$toStr = _product$price2.toString) === null || _product$price2$toStr === void 0 ? void 0 : _product$price2$toStr.call(_product$price2)) || (activityDetail === null || activityDetail === void 0 ? void 0 : (_activityDetail$price = activityDetail.price) === null || _activityDetail$price === void 0 ? void 0 : (_activityDetail$price2 = _activityDetail$price.toString) === null || _activityDetail$price2 === void 0 ? void 0 : _activityDetail$price2.call(_activityDetail$price)) || '- -')), (!hasBuy && !disabled || isDownloadButton) && (customText || text || /*#__PURE__*/React.createElement(Fragment, null, "\xA0")), (!!hasBuy || disabled) && !isDownloadButton && ProductTypeBtnTexts[productType]));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isDev && fixedBottom && !justPay && /*#__PURE__*/React.createElement("div", null, "\u6309\u94AE\u5360\u4F4D\uFF08\u6700\u7EC8\u9875\u9762\u4E0D\u5C55\u793A\uFF09"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container"),
    style: _objectSpread(_objectSpread({
      display: tabVisible ? 'block' : 'none'
    }, fixedStyle), style),
    id: title ? "me-".concat(title) : undefined
  }, /*#__PURE__*/React.createElement(ActivityButton, null), /*#__PURE__*/React.createElement(Payment, {
    productInfo: productInfo,
    visible: visible,
    setVisible: setVisible,
    payType: payType,
    setPayType: setPayType,
    isDev: isDev || isPreview,
    initEvent: initEvent
  }, /*#__PURE__*/React.createElement(ActivityButton, {
    customText: "\u7ACB\u5373\u652F\u4ED8"
  }))), /*#__PURE__*/React.createElement(GuidePage, {
    visible: !!guideOpen,
    onClose: function onClose() {
      return guideClose === null || guideClose === void 0 ? void 0 : guideClose();
    }
  }));
});

// ts定义在这里，使用时类型断言
var EnhancedButton = EnhanceComponent(Button);
EnhancedButton.settings = setting;
export default EnhancedButton;